import * as $ from "jquery";
import "slick-carousel";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    el: ".js-related-posts-slider-wrap",
    ui: {
        sliderMain: ".js-slider-main",
    }
})
export default class ViewController extends Marionette.View<Backbone.Model>{
    constructor() {
        super();
    }

    // --------------------------------
    // Events
    // --------------------------------

    // Slick Slider event called every time Slick recalculates position
    @on("setPosition @ui.sliderMain")
    onSliderSetPosition(JQueryEventObject: any) {
        this.resizeSlides();
    }


    // --------------------------------
    // Functions
    // --------------------------------

    onRender() {
        console.log("related posts slider viewcontroller rendered");
        this.initSlider();
    }

    // Force all tile heights within slider to be:
    // 1) the same, and
    // 2) sized to accommodate greatest amount of content across a tile group

    // https://jboullion.com/force-height-slick-slides/
    // ======================================================================

    resizeSlides() {
        this.ui.sliderMain.find('.slick-slide').height('auto');

        let slickTrack = this.ui.sliderMain.find('.slick-track');
        const slickTrackHeight = $(slickTrack).height();

        this.ui.sliderMain.find('.slick-slide').css('height', slickTrackHeight + 'px');
    }

    // ======================================================================

    initSlider() {
        // NOTE: set `centerMode: true` IF you want to
        // center and see edges of off-screen cards

        this.ui.sliderMain.slick({
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            centerMode: true,
            centerPadding: "40px",
        });
    }
}



// WEBPACK FOOTER //
// ./django/project/@static/@modules/related-posts-slider/controller.ts